export { default } from "./LessonResourceGraphicsItem";
export type { LessonResourceGraphicsItemProps } from "./LessonResourceGraphicsItem";
